
(function(){
"use strict";
if (customElements.get("bloom-quiz")) return;
customElements.define("bloom-quiz", class extends HTMLElement {
  connectedCallback() {
    this.dispose?.();
    this.dispose = initializeQuiz(this);
  }
  disconnectedCallback() {
    this.dispose?.();
    this.dispose = null;
  }
});
function initializeQuiz(host) {
var lifecycle = new AbortController();
var stateKey = window.Shopify?.designMode ? "bloomQuizEditorState" : "bloomQuizState";

/* ============================================================
   CONFIG — the only things you normally change
   ============================================================ */
var config = JSON.parse(host.querySelector("#bqConfig").textContent);
var END_URL = config.productUrl;
var WEEKS_OUT = config.weeks;
function img(n){ return config.media[n] || ""; }
function raw(n){ return img(n); }

var IMG = {
  paws:   img("bp-q-ba2-before"),   /* stained, licked paws */
  belly:  img("bp-q-ba1-before"),   /* red belly / groin */
  ears:   img("bp-q-ba3-before"),   /* inflamed ear */
  night:  img("bp-sp-morning"),     /* dog asleep, settled */
  happy:  img("bp-ev-happydog"),
  /* NOTE: bp-sb-couch-pit / bp-sb-hero-kitchen / bp-sb-kitchen-golden /
     bp-ev-owner / bp-ev-guarantee / bp-rl-r3 / bp-rl-r5 / bp-ev5-trust are all the
     SAME synthetic model. Never put more than one of them on a page. */
  dropper:img("bp-ev-dropper",700),        /* pump over the food bowl */
  inside: raw("bp-rl-r4-inside",800),      /* what's inside every drop */
  dose:   raw("bp-rl-r10-dose",800),       /* daily dose by weight */
  baBefore1: img("bp-q-ba1-before"), baAfter1: img("bp-q-ba1-after"),
  baBefore2: img("bp-q-ba2-before"), baAfter2: img("bp-q-ba2-after"),
/*BQP03*/
  rev: [1,2,3,4,5,6,7,8].map(function(i){ return img("bp-rv2-r"+i,150); }),
  /* eight different owners — used as a wall, never as a single hero */
  wall: [1,2,3,4,5,6,7,8].map(function(i){ return img("bp-rv2-r"+i,260); })
};

/* ============================================================
   STEPS
   type: cards | list | multi | scale | info | compare | ba | reviews
         | summary | chart | loader | result
   ============================================================ */
var STEPS = [
{ type:"cards", key:"age", first:true,
  h1:['Your dog’s ', ['hl','itch relief plan'], ', built from 100,000+ dogs'],
  badge:"1-minute quiz",
  cta:"Continue",
  opts:[
    {v:"Under 2", big:"&lt;2",  label:"Under 2"},
    {v:"2-5",     big:"2–5", label:"2–5 years"},
    {v:"6-9",     big:"6–9", label:"6–9 years"},
    {v:"10+",     big:"10+",   label:"10 or older"}
  ]},

{ type:"text", key:"name", cta:"Continue", skip:"Skip",
  q:"What’s your dog’s name?",
  sub:"So we can put it on the plan.",
  placeholder:"e.g. Bella" },

{ type:"cards", key:"where", cta:"Continue",
  q:"Where is it worst on {name} right now?",
  sub:"Pick the one that looks closest.",
  opts:[
    {v:"Paws",  img:IMG.paws,  label:"Paws"},
    {v:"Belly", img:IMG.belly, label:"Belly &amp; groin"},
    {v:"Ears",  img:IMG.ears,  label:"Ears"},
    {v:"Everywhere", ico:"🐕", label:"More than one"}
  ]},

{ type:"info",
  wall:true,
  h1:["You’re in the right place"],
  stat:"100,000+",
  body:"dogs have been through this plan. Most of their owners arrived exactly where you are now — out of ideas, and tired.",
  cta:"Continue" },

{ type:"list", key:"duration",
  q:"How long has {name} been like this?",
  opts:[
    {v:"<3 months"},{v:"3–12 months"},{v:"1–3 years"},
    {v:"As long as we’ve had them"}
  ]},

{ type:"list", key:"symptom",
  q:"What does a bad day look like?",
  opts:[
    {v:"Scratching and biting, constantly", emo:"😓"},
    {v:"Licking the paws raw", emo:"🐾"},
    {v:"Head shaking, ear scratching", emo:"👂"},
    {v:"Hot spots and bald patches", emo:"🔴"},
    {v:"A smell that keeps coming back", emo:"👃"}
  ]},

{ type:"list", key:"goal",
  q:"What would you fix first?",
  opts:[
    {v:"Stop the scratching"},
    {v:"Get the coat back"},
    {v:"Sleep through the night"},
    {v:"All of it"}
  ]},

{ type:"info",
  h1:["First goal set ✓"],
  body:"That is the one we build the plan around. A few more questions and we can show you where {name} actually stands.",
  cta:"Continue" },

{ type:"scale", key:"severity",
  q:"How bad is the scratching on a normal day?",
  sub:"1 is barely noticeable. 5 is all day, every day.",
  ends:["Barely","Non-stop"] },

{ type:"list", key:"night",
  q:"Does {poss} scratching wake you at night?",
  opts:[
    {v:"Most nights"},{v:"A few times a week"},
    {v:"Occasionally"},{v:"No, nights are fine"}
  ]},

{ type:"info", when:function(a){ return a.night==="Most nights"||a.night==="A few times a week"; },
  img:IMG.night,
  h1:["The 2am part is the part nobody warns you about"],
  body:"The thump of a back leg. The chewing. The collar shaking down the hall. You are up, so they are up, and it goes on for months.  Owners tell us the quiet nights are the first thing they notice — usually before they notice the coat.",
  cta:"Continue" },

{ type:"info",
  img:IMG.belly,
  h1:["The itch was never the ", ["hl","actual problem"]],
  body:"{Poss} skin is a barrier. It holds moisture in and keeps allergens, bacteria and yeast out. That barrier thins with age and wears down under constant inflammation.<br><br>Once it does, everything gets through — and the scratching is just the alarm going off. Shampoos wash the surface. Pills quiet the alarm. <strong>Neither one rebuilds the barrier that let it all in.</strong><br><br>Which is why it always comes back.",
  cta:"What happens if I leave it?" },

{ type:"info",
  img:IMG.ears,
  h1:["What another year of this ", ["hl","costs {name}"]],
  body:"A barrier under strain does not hold still. Every scratch-and-heal cycle leaves the skin thicker and darker, and thickened skin is worse at its job than the skin it replaced — so the next flare starts from further back.<br><br>Add age on top, because the barrier thins anyway, and you get the pattern owners describe to us constantly: <strong>it used to be seasonal, now it is all year.</strong><br><br>The dogs that turn around fastest are the ones whose owners started before the skin got thick.",
  note:"You have been at this for {since}.",
  cta:"So what rebuilds it?" },

{ type:"info",
  img:IMG.inside, natural:true,
  h1:["What actually goes in ", ["hl","the bowl"]],
  body:"Collagen I for the structure of the skin. Collagen III for repairing it. Hyaluronic acid underneath for hydration, and glucosamine for the joints they use all day.<br><br>Liquid, so it absorbs instead of passing through — and 100% deep-sea cod, no chicken, because chicken is one of the things dogs react to.<br><br>One pump on dinner. That is the entire ask.",
  cta:"Continue" },

{ type:"multi", key:"tried", cta:"Continue",
  q:"What have you already tried?",
  sub:"Choose all that apply.",
  opts:[
    {v:"Medicated shampoos", emo:"🧴"},
    {v:"Switching food", emo:"🥩"},
    {v:"Apoquel, steroids or antihistamines", emo:"💊"},
    {v:"Allergy testing", emo:"🧪"},
    {v:"Other supplements", emo:"💊"},
    {v:"Repeat vet visits", emo:"🏥"},
    {v:"Nothing yet", emo:"➖", solo:true}
  ]},

{ type:"info", when:function(a){ return (a.tried||[]).indexOf("Apoquel, steroids or antihistamines")>-1; },
  h1:["About the pills"],
  body:"Keep giving whatever your vet prescribed — that is their call, not ours.<br><br>But it is worth knowing what those pills are doing. They interrupt the itch signal. That is the job, and they are good at it. What they do not do is rebuild the barrier that started the signal, which is why the itch is usually waiting when the course ends.<br><br>Bloom Triple Collagen works on the other half of the problem, and it sits alongside what your vet has you on.",
  cta:"Continue" },

{ type:"list", key:"breed",
  q:"What kind of dog are we working with?",
  opts:[
    {v:"Pit bull, Staffy or bully breed"},
    {v:"Retriever, Lab or Shepherd"},
    {v:"Bulldog, Frenchie or short-nosed"},
    {v:"Small or toy breed"},
    {v:"Mixed or something else"}
  ]},

{ type:"reviews",
  h1:["Owners who were exactly here"],
  stat:"4.8",
  statSub:"from 3,300+ reviews",
  cta:"Continue" },

{ type:"compare",
  h1:["Why this works when the ", ["hl","other things didn’t"]],
  cta:"Continue" },

{ type:"ba",
  h1:["Same dogs. ", ["hl","Weeks apart."]],
/*BQP04*/
  body:"Sent in by owners, unedited. Results vary — these are not the fastest cases, they are the typical ones.",
  cta:"Continue" },

{ type:"list", key:"diet",
  q:"What is {name} eating now?",
  opts:[
    {v:"Dry kibble"},{v:"Wet or fresh food"},
    {v:"Raw"},{v:"A mix"}
  ]},

{ type:"list", key:"commit",
  img:IMG.dropper,
  q:"Could you add one pump to {poss} dinner each day?",
  sub:"That is the entire routine. No pills, no baths, no schedule.",
  opts:[
    {v:"Yes, easily", emo:"👍"},
    {v:"Probably", emo:"🙌"},
    {v:"I’d have to remember", emo:"🤔"}
  ]},

{ type:"summary" },
{ type:"chart" },

{ type:"list", key:"ready",
  q:"Honestly — are you ready to start?",
  sub:"No wrong answer. It changes what we show you next.",
  opts:[
    {v:"Yes, I want this sorted", emo:"💪"},
    {v:"I want to, but I’ve been let down before", emo:"😔"},
    {v:"Still not sure", emo:"🤔"}
  ]},

{ type:"info", when:function(a){ return a.ready && a.ready.indexOf("let down") > -1; },
  h1:["Then you are exactly who this was built for"],
  body:"Everyone who works here has heard the same sentence: <em>I have tried everything.</em> Usually it is true. The shampoos, the food, the pills, the vet bills — and a dog still scratching.<br><br>You were not failing {name}. You were handed things that treat the surface, for a problem that lives underneath it.<br><br>So we do not ask you to believe anything. Feed it for 90 days. If {name} is no better, we send your money back and you have lost nothing but the time.",
  cta:"Fair enough" },

{ type:"loader" },
{ type:"result" }
];

// Theme-editor copy blocks retain stable answer values and conditional steps.
(config.steps || []).forEach(function(copy){
  var step = STEPS[Number(copy.step)];
  if (!step) return;
  function heading(text){return text.replace(/<strong>/g,'<span class="hl">').replace(/<\/strong>/g,'</span>');}
  if (copy.heading) {
    if (step.h1 || ["summary","chart","result"].includes(step.type)) step.h1 = [heading(copy.heading)];
    else step.q = copy.heading;
  }
  ["sub","cta","badge","note","stat","statSub","placeholder","skip","resultScore","resultHold","resultRoutine","resultDose","resultNight","resultDay","resultRebuild","resultRefund","resultDoseAlt","resultRisk","resultSold","resultBatch","resultTrust1","resultTrust2","resultTrust3","resultNote","chartCaption","axisHigh","axisMid","axisLow","loadingLines","verifiedLabel"].forEach(function(key){if(copy[key]) step[key] = copy[key];});
  if (copy.body) step.body = copy.body.replace(/^<p>/, "").replace(/<\/p>$/, "").replace(/<\/p>\s*<p>/g,"<br><br>");
  if (step.opts && copy.options) step.opts.forEach(function(option,index){if(copy.options[index]) option.label = copy.options[index];});
});

/* ============================================================
   ENGINE
   ============================================================ */
var root = host.querySelector("#bqRoot"),
    bar  = host.querySelector("#bqBar"),
    back = host.querySelector("#bqBack");

var answers = {}, i = 0, history = [], timers = [];
function later(fn, ms){ var id = window.setTimeout(fn, ms); timers.push(id); return id; }
function repeat(fn, ms){ var id = window.setInterval(fn, ms); timers.push(id); return id; }
function cancelTimers(){ timers.forEach(function(id){ window.clearTimeout(id); window.clearInterval(id); }); timers = []; }
try {
  var saved = JSON.parse(sessionStorage.getItem(stateKey) || "null");
  if(saved && saved.version === 1 && Number.isInteger(saved.index) && saved.index >= 0 && saved.index < STEPS.length){
    answers = saved.answers || {}; i = saved.index;
    history = (saved.history || []).filter(function(n){ return Number.isInteger(n) && n >= 0 && n < STEPS.length; });
  }
} catch(e) {}


function visible(n){ var s=STEPS[n]; return s && (!s.when || s.when(answers)); }
function nextIndex(from){ var n=from; while(n<STEPS.length && !visible(n)) n++; return n; }
function esc(s){ return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;"); }

/* ---- personalisation: every screen can reference {name}, {Name}, {age}, {spot}, {since}, {nights} ---- */
function vars(){
  var n = esc((answers.name||"").trim());
  var AGE = {"Under 2":"under-2","2-5":"2-to-5-year-old","6-9":"6-to-9-year-old","10+":"10-year-old"};
  var SPOT = {"Paws":"paws","Belly":"belly","Ears":"ears","Everywhere":"skin"};
  var SINCE = {"<3 months":"a few months","3–12 months":"most of a year","1–3 years":"years now","As long as we’ve had them":"their whole life with you"};
  var NIGHTS = {"Most nights":"most nights","A few times a week":"a few nights a week","Occasionally":"now and then","No, nights are fine":"not at night"};
  return {
    name: n || "your dog",
    Name: n || "Your dog",
    poss: n ? n + "’s" : "your dog’s",
    Poss: n ? n + "’s" : "Your dog’s",
    age:  AGE[answers.age] || "",
    spot: SPOT[answers.where] || "skin",
    since: SINCE[answers.duration] || "a while",
    nights: NIGHTS[answers.night] || ""
  };
}
function tok(s){
  if(s == null) return s;
  var v = vars();
  return String(s).replace(/\{(\w+)\}/g, function(m,k){ return (k in v) ? v[k] : m; });
}

function h1(parts){
  return parts.map(function(p){
    return Array.isArray(p) ? '<span class="'+p[0]+'">'+tok(p[1])+'</span>' : tok(p);
  }).join("");
}

function progress(){
  var total = STEPS.length, done = i;
  bar.style.width = Math.max(4, Math.min(100, Math.round(done/(total-1)*100))) + "%";
  back.classList.toggle("on", history.length>0 && i<STEPS.length-1);
}

function go(n){
  history.push(i);
  i = nextIndex(n);
  render();
  window.scrollTo({top:0, behavior:"instant"});
}
back.addEventListener("click", function(){
  if(!history.length) return;
  i = history.pop(); render(); window.scrollTo({top:0});
}, {signal:lifecycle.signal});

var TICK = '<div class="bq-tick"><svg viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg></div>';
var STARS = "★★★★★";

function ctaBtn(label, disabled){
  return '<button class="bq-cta" id="bqGo"'+(disabled?" disabled":"")+'>'+label+
         ' <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
}
function bindGo(){
  var b = host.querySelector("#bqGo");
  if(b) b.addEventListener("click", function(){ go(i+1); });
  return b;
}

/* ---------- date helpers ---------- */
function targetDate(){
  var d = new Date(); d.setDate(d.getDate() + WEEKS_OUT*7);
  return d;
}
function fmt(d){ return d.toLocaleDateString("en-US",{month:"long", day:"numeric", year:"numeric"}); }
function fmtShort(d){ return d.toLocaleDateString("en-US",{month:"short", day:"numeric"}); }

/* ---------- score: drives the gauge + copy ---------- */
function score(){
  var s = 62;                                     /* start: "needs work" */
  var sev = parseInt(answers.severity||3,10);
  s -= (sev-1)*7;                                 /* worse scratching -> lower */
  if(answers.duration==="1–3 years") s -= 6;
  if(answers.duration==="As long as we’ve had them") s -= 10;
  if(answers.night==="Most nights") s -= 8;
  else if(answers.night==="A few times a week") s -= 4;
  if(answers.symptom==="Hot spots and bald patches") s -= 6;
  if((answers.tried||[]).length >= 3) s -= 5;
  if(answers.age==="10+") s -= 4;
  return Math.max(9, Math.min(74, Math.round(s)));
}
function band(v){ return v<30 ? "Low" : v<55 ? "Fair" : "Good"; }
var verdictDefaults = {"low_title": "Barrier badly worn down", "low_body": "At this level the skin has almost no defence left. Allergens, bacteria and yeast pass straight through, and every scratch opens the door wider — which is why nothing applied to the surface has held. The barrier itself has to be rebuilt from the inside, and it can be.", "fair_title": "Barrier under strain", "fair_body": "The skin is losing moisture faster than it holds it, so allergens and bacteria get through easily and the scratching keeps re-starting the cycle. It is addressable — the barrier rebuilds when it is fed what it is missing.", "good_title": "Barrier slipping, caught early", "good_body": "There is still a working barrier here, which is the good news — you are catching this before the damage compounds. Left alone it thins further with age and the flare-ups get longer. Fed properly, this is the easiest stage to turn around."};
function verdict(v){
  var level = v < 30 ? "low" : v < 55 ? "fair" : "good";
  var copy = config.verdict || {};
  function text(part){ var key = level + "_" + part; return esc(copy[key] || verdictDefaults[key]); }
  return {t:text("title"), p:text("body")};
}

/* ---------- renderers ---------- */
var R = {};

R.cards = function(s){
/*BQP05*/
  var head = s.h1 ? '<h1 class="bq-h1">'+h1(s.h1)+'</h1>' : '<h2 class="bq-q">'+tok(s.q)+'</h2>';
  var html = head
    + (s.badge ? '<div class="bq-badge">'+s.badge+'</div>' : "")
    + (s.sub ? '<p class="bq-sub">'+tok(s.sub)+'</p>' : "")
    + '<div class="bq-grid'+(s.opts.every(function(o){ return !o.img; }) ? " all-plain" : "")+'">'
    + s.opts.map(function(o){
        var inner = o.img
          ? '<div class="bq-card-img"><img src="'+o.img+'" alt="'+esc(o.label)+'" loading="lazy"></div>'
          : '<div class="bq-card-img">'+(o.big?'<span class="bq-card-big">'+o.big+'</span>':'<span class="bq-card-ico">'+o.ico+'</span>')+'</div>';
        return '<button type="button" class="bq-card'+(o.img?"":" plain")+'" data-v="'+esc(o.v)+'">'+TICK+inner
             + '<div class="bq-card-label">'+o.label+'</div></button>';
      }).join("")
    + '</div>' + ctaBtn(s.cta||"Continue", true);
  root.innerHTML = html;
  var btn = bindGo();
  root.querySelectorAll(".bq-card").forEach(function(c){
    c.addEventListener("click", function(){
      root.querySelectorAll(".bq-card").forEach(function(x){ x.classList.remove("sel"); });
      c.classList.add("sel");
      answers[s.key] = c.dataset.v;
      btn.disabled = false;
    });
  });
};

R.list = function(s){
  root.innerHTML = (s.img ? '<div class="bq-hero"><img src="'+s.img+'" alt="" loading="lazy"></div>' : "")
    + '<h2 class="bq-q">'+tok(s.q)+'</h2>'
    + (s.sub ? '<p class="bq-sub">'+tok(s.sub)+'</p>' : "")
    + '<div class="bq-list">'
    + s.opts.map(function(o){
        return '<button class="bq-opt" data-v="'+esc(o.v)+'">'
             + (o.emo ? '<span class="emo">'+o.emo+'</span>' : "")
             + '<span class="lbl">'+(o.label||o.v)+'</span><span class="dot"></span></button>';
      }).join("")
    + '</div>';
  root.querySelectorAll(".bq-opt").forEach(function(b){
    b.addEventListener("click", function(){
      root.querySelectorAll(".bq-opt").forEach(function(x){ x.classList.remove("sel"); });
      b.classList.add("sel");
      root.querySelectorAll("button").forEach(function(button){ button.disabled = true; });
      answers[s.key] = b.dataset.v;
      later(function(){ go(i+1); }, 230);      /* auto-advance */
    });
  });
};

R.multi = function(s){
  root.innerHTML = '<h2 class="bq-q">'+tok(s.q)+'</h2>'
    + (s.sub ? '<p class="bq-sub">'+tok(s.sub)+'</p>' : "")
    + '<div class="bq-list">'
    + s.opts.map(function(o){
        return '<button class="bq-opt multi" data-v="'+esc(o.v)+'"'+(o.solo?' data-solo="1"':'')+'>'
             + (o.emo ? '<span class="emo">'+o.emo+'</span>' : "")
             + '<span class="lbl">'+(o.label||o.v)+'</span><span class="dot"></span></button>';
      }).join("")
    + '</div>' + ctaBtn(s.cta||"Continue", true);
  var btn = bindGo();
  answers[s.key] = answers[s.key] || [];
  root.querySelectorAll(".bq-opt").forEach(function(b){
    b.addEventListener("click", function(){
      var v = b.dataset.v, list = answers[s.key];
      if(b.dataset.solo){
        root.querySelectorAll(".bq-opt").forEach(function(x){ x.classList.remove("sel"); });
        list = list.indexOf(v) > -1 ? [] : [v];
        b.classList.toggle("sel", list.length>0);
      } else {
        var solo = root.querySelector('.bq-opt[data-solo]');
        if(solo){ solo.classList.remove("sel"); list = list.filter(function(x){ return x!==solo.dataset.v; }); }
        if(list.indexOf(v)>-1){ list = list.filter(function(x){ return x!==v; }); b.classList.remove("sel"); }
        else { list.push(v); b.classList.add("sel"); }
      }
      answers[s.key] = list;
      btn.disabled = list.length===0;
    });
  });
};

R.text = function(s){
  root.innerHTML = '<h2 class="bq-q">'+tok(s.q)+'</h2>'
    + (s.sub ? '<p class="bq-sub">'+tok(s.sub)+'</p>' : "")
    + '<input class="bq-input" id="bqIn" type="text" autocomplete="off" autocapitalize="words"'
    + ' maxlength="24" placeholder="'+esc(s.placeholder||"")+'" value="'+esc(answers[s.key]||"")+'">'
    + ctaBtn(s.cta||"Continue")
    + (s.skip ? '<button class="bq-skip" id="bqSkip">'+s.skip+'</button>' : "");
  var input = host.querySelector("#bqIn");
  function save(){ answers[s.key] = input.value.trim().slice(0,24); try{ sessionStorage.setItem(stateKey, JSON.stringify({version:1,index:i,history:history,answers:answers})); }catch(e){} }
  input.addEventListener("input", save);
  input.addEventListener("keydown", function(e){ if(e.key==="Enter"){ save(); go(i+1); } });
  host.querySelector("#bqGo").addEventListener("click", save);
  var sk = host.querySelector("#bqSkip");
  if(sk) sk.addEventListener("click", function(){ answers[s.key] = ""; go(i+1); });
  bindGo();
};

R.scale = function(s){
  root.innerHTML = '<h2 class="bq-q">'+tok(s.q)+'</h2>'
    + (s.sub ? '<p class="bq-sub">'+tok(s.sub)+'</p>' : "")
    + '<div class="bq-scale">'+[1,2,3,4,5].map(function(n){
        return '<button data-v="'+n+'">'+n+'</button>'; }).join("")+'</div>'
    + '<div class="bq-scale-ends"><span>'+s.ends[0]+'</span><span>'+s.ends[1]+'</span></div>';
  root.querySelectorAll(".bq-scale button").forEach(function(b){
    b.addEventListener("click", function(){
      root.querySelectorAll(".bq-scale button").forEach(function(x){ x.classList.remove("sel"); });
      b.classList.add("sel");
      root.querySelectorAll("button").forEach(function(button){ button.disabled = true; });
      answers[s.key] = b.dataset.v;
      later(function(){ go(i+1); }, 230);
    });
  });
};

R.info = function(s){
  root.innerHTML =
      (s.wall ? '<div class="bq-wall">'+IMG.wall.map(function(u){
          return '<img src="'+u+'" alt="" loading="lazy">'; }).join("")+'</div>' : "")
    + (s.img ? '<div class="bq-hero'+(s.natural?" nat":"")+'"><img src="'+s.img+'" alt="" loading="lazy"></div>' : "")
    + (s.h1 ? '<h1 class="bq-h1">'+h1(s.h1)+'</h1>' : "")
    + (s.stat ? '<div class="bq-stat">'+s.stat+'</div>' : "")
    + (s.body ? '<p class="bq-body">'+tok(s.body)+'</p>' : "")
    + (s.note ? '<p class="bq-note">'+tok(s.note)+'</p>' : "")
    + ctaBtn(s.cta||"Continue");
  bindGo();
};

function editableReviews(step, fallback){
  var configured = (config.reviews || []).filter(function(review){return Number(review.step) === step;});
  if (!configured.length) return fallback;
  return configured.map(function(review){return {n:review.name || "", t:review.title || "", x:review.body || "", m:review.meta || ""};});
}

R.reviews = function(s){
  var revs = [
    {n:"Denise M.", t:"The nights got quiet first", x:"Nine years of this. Four weeks in and she sleeps through. I did not expect that to be the thing I noticed.", m:"Verified · 2 days ago"},
    {n:"Ray T.",    t:"His paws are not pink anymore", x:"He chewed them raw every evening. That has stopped. The fur is coming back in now.", m:"Verified · 6 days ago"},
    {n:"Sharon K.", t:"I had given up, honestly", x:"We had done the shampoos, the food, the vet. This is the first thing that changed anything.", m:"Verified · 1 week ago"},
    {n:"Bernie H.", t:"Coat came back thick", x:"Bald patches on her back have filled in. Took about six weeks before it was obvious.", m:"Verified · 2 weeks ago"}
  ];
  revs = editableReviews(17, revs);
  root.innerHTML = '<h1 class="bq-h1">'+h1(s.h1)+'</h1>'
    + '<div class="bq-stat">'+s.stat+' <span style="font-size:22px">★</span></div>'
    + '<p class="bq-sub" style="margin-top:-12px">'+s.statSub+'</p>'
    + '<div class="bq-revs">'
    + revs.map(function(r,k){
/*BQP06*/
        return '<div class="bq-rev"><div class="hd"><img class="av" src="'+IMG.rev[k]+'" alt="" loading="lazy">'
             + '<div><div class="nm">'+esc(r.n)+'</div><div class="mt">'+esc(r.m)+'</div></div></div>'
             + '<div class="st">'+STARS+'</div><div class="ti">'+esc(r.t)+'</div><div class="tx">'+esc(r.x)+'</div></div>';
      }).join("")
    + '</div>' + ctaBtn(s.cta||"Continue");
  bindGo();
};

R.compare = function(s){
  var rows = [
    ["Calms the itch today", 1, 1],
    ["Rebuilds the skin barrier", 0, 1],
    ["Works while they age", 0, 1],
    ["Fits in the dinner bowl", 0, 1],
    ["Nothing to remember daily", 0, 1],
    ["90-day money back", 0, 1]
  ];
  if (config.comparisonRows && config.comparisonRows.length) rows = config.comparisonRows.map(function(row){return [row.label || "", row.other, row.bloom];});
  function column(value, fallback){return esc(value || fallback).replace(/\r?\n/g,"<br>");}

  root.innerHTML = '<h1 class="bq-h1">'+h1(s.h1)+'</h1>'
    + '<div class="bq-cmp"><table><thead><tr><th></th><th>'+column(config.comparisonOther, 'Shampoos\n& pills')+'</th><th class="us">'+column(config.comparisonBloom, 'Bloom\nCollagen')+'</th></tr></thead><tbody>'
    + rows.map(function(r){
        return '<tr><td>'+esc(r[0])+'</td>'
             + '<td>'+(r[1]?'<span class="yes">✓</span>':'<span class="no">✕</span>')+'</td>'
             + '<td class="us">'+(r[2]?'<span class="yes">✓</span>':'<span class="no">✕</span>')+'</td></tr>';
      }).join("")
    + '</tbody></table></div>' + ctaBtn(s.cta||"Continue");
  bindGo();
};

R.ba = function(s){
  root.innerHTML = '<h1 class="bq-h1">'+h1(s.h1)+'</h1>'
    + '<div class="bq-ba">'
    + '<figure><figcaption>Before</figcaption><img src="'+IMG.baBefore1+'" alt="Before" loading="lazy"></figure>'
    + '<figure class="aft"><figcaption>After</figcaption><img src="'+IMG.baAfter1+'" alt="After" loading="lazy"></figure>'
    + '<figure><figcaption>Before</figcaption><img src="'+IMG.baBefore2+'" alt="Before" loading="lazy"></figure>'
    + '<figure class="aft"><figcaption>After</figcaption><img src="'+IMG.baAfter2+'" alt="After" loading="lazy"></figure>'
    + '</div>'
    + (s.body ? '<p class="bq-sub">'+tok(s.body)+'</p>' : "")
    + ctaBtn(s.cta||"Continue");
  bindGo();
};

var summaryDefaults = {"low": "Low", "fair": "Fair", "good": "Good", "score_prefix": "You =", "itch_label": "Itch level", "itch_high": "High", "itch_elevated": "Elevated", "barrier_label": "Skin barrier", "barrier_status": "Compromised", "coat_label": "Coat condition", "coat_status": "Needs rebuilding"};
function summaryCopy(key){ return esc((config.summary || {})[key] || summaryDefaults[key]); }

R.summary = function(s){
  var v = score(), pct = Math.round(v/100*100);
  var itch = summaryCopy(parseInt(answers.severity||3,10) >= 4 ? "itch_high" : "itch_elevated");
  var v2 = vars();
  root.innerHTML = '<h1 class="bq-h1">'+(s.h1?h1(s.h1):v2.Poss+' profile')+'</h1>'
    + '<p class="bq-sub" style="margin-top:-10px">A '+(v2.age?v2.age+" ":"")+'dog, '+v2.spot
      +' worst affected, '+v2.since+(v2.nights&&v2.nights!=="not at night"?", waking you "+v2.nights:"")+'.</p>'
    + '<div class="bq-gauge"><div class="bq-gauge-flag" id="bqFlag">'+summaryCopy("score_prefix")+' '+v+'</div>'
    + '<div class="bq-gauge-track"><div class="bq-gauge-pin" id="bqPin"></div></div>'
    + '<div class="bq-gauge-ends"><span>'+summaryCopy('low')+'</span><span>'+summaryCopy('fair')+'</span><span>'+summaryCopy('good')+'</span></div></div>'
    + '<div class="bq-alert"><h3><span>⚠</span> '+verdict(v).t+'</h3><p>'+verdict(v).p+'</p></div>'
    + '<div class="bq-rows">'
    + row("🔥",summaryCopy("itch_label"), itch, false)
    + row("🛡",summaryCopy("barrier_label"),summaryCopy("barrier_status"), false)
    + row("✨",summaryCopy("coat_label"),summaryCopy("coat_status"), false)
    + '</div>' + ctaBtn(s.cta||"See my plan");
  later(function(){
    var p = Math.max(5, Math.min(93, pct));
    host.querySelector("#bqPin").style.left = p+"%";
    host.querySelector("#bqFlag").style.left = p+"%";
  }, 120);
  bindGo();
  function row(ico,k,val,good){
    return '<div class="bq-row"><div class="ico">'+ico+'</div><div><div class="k">'+k+'</div>'
         + '<div class="v'+(good?" good":"")+'">'+val+'</div></div></div>';
  }
};

R.chart = function(s){
  var d = targetDate(), now = new Date();
  root.innerHTML = '<h1 class="bq-h1">'+h1(s.h1||["The plan we’d put ", ["hl","{name}"], " on"])+'</h1>'
    + '<p class="bq-sub">'+(s.sub||'Based on your answers, owners in your situation typically see settled skin by')+'</p>'
    + '<div class="bq-stat" style="font-size:26px;letter-spacing:0">'+fmt(d)+'</div>'
    + '<div class="bq-chart"><div class="cap">'+esc(s.chartCaption||"Skin comfort")+'</div>'
    + '<div class="plot"><span class="ax hi">'+esc(s.axisHigh||"High")+'</span><span class="ax mid">'+esc(s.axisMid||"Mid")+'</span><span class="ax lo">'+esc(s.axisLow||"Low")+'</span>'
    + '<svg viewBox="0 0 300 150" preserveAspectRatio="none" aria-hidden="true">'
    + '<defs><linearGradient id="bqg" x1="0" x2="0" y1="0" y2="1">'
    + '<stop offset="0%" stop-color="#21317D" stop-opacity=".30"/><stop offset="100%" stop-color="#21317D" stop-opacity="0"/>'
    + '</linearGradient></defs>'
    + '<line x1="30" y1="20" x2="300" y2="20" stroke="#D8DBE4" stroke-dasharray="4 4"/>'
    + '<line x1="30" y1="75" x2="300" y2="75" stroke="#D8DBE4" stroke-dasharray="4 4"/>'
    + '<line x1="30" y1="130" x2="300" y2="130" stroke="#D8DBE4" stroke-dasharray="4 4"/>'
    + '<path id="bqArea" d="M0,130 C110,128 175,105 300,20 L300,150 L0,150 Z" fill="url(#bqg)"/>'
    + '<path id="bqLine" d="M0,130 C110,128 175,105 300,20" fill="none" stroke="#21317D" stroke-width="3" stroke-linecap="round"/>'
    + '<circle cx="2" cy="130" r="5" fill="#21317D"/><circle cx="297" cy="20" r="5" fill="#21317D"/>'
    + '</svg></div>'
    + '<div class="dates"><span>'+fmtShort(now)+'</span><span>'+fmtShort(d)+'</span></div></div>'
    + ctaBtn(s.cta||"Build my plan");
  var line = host.querySelector("#bqLine");
  if(line && line.getTotalLength){
    var L = line.getTotalLength();
    line.style.strokeDasharray = L; line.style.strokeDashoffset = L;
    line.getBoundingClientRect();
    line.style.transition = "stroke-dashoffset 1.4s cubic-bezier(.16,1,.3,1)";
    line.style.strokeDashoffset = 0;
  }
  bindGo();
};

R.loader = function(s){
  var vl = vars();
  var lines = [
    "Reading your answers…",
    "Scoring "+vl.poss+" barrier…",
    "Matching "+vl.name+" against 100,000+ dogs…",
    "Factoring in age and "+vl.since+" of history…",
    "Building "+vl.poss+" plan…"
  ];
  if (s.loadingLines) {
    var values = vars(), entities = {amp:'&', lt:'<', gt:'>', quot:'"', '#39':"'"};
    lines = s.loadingLines.split(/\r?\n/).filter(function(line){return line.trim();}).map(function(line){
      return line.replace(/\{(\w+)\}/g,function(match,key){
        return values[key] === undefined ? match : String(values[key]).replace(/&(amp|lt|gt|quot|#39);/g,function(_,entity){return entities[entity];});
      });
    });
  }
  var revs = [
    {n:"Margie P.", t:"Four weeks", x:"The licking stopped before the coat changed. I nearly missed it."},
    {n:"Tanya W.",  t:"Ears finally clear", x:"No head shaking for the first time in two years."},
    {n:"Kim L.",    t:"Worth it", x:"One pump on dinner. That really is all we do."}
  ];
  revs = editableReviews(26, revs);
  root.innerHTML = '<div class="bq-ring"><svg viewBox="0 0 120 120">'
    + '<circle class="bg" cx="60" cy="60" r="52"/>'
    + '<circle class="fg" id="bqFg" cx="60" cy="60" r="52" stroke-dasharray="326.7" stroke-dashoffset="326.7"/>'
    + '</svg><b id="bqPct">0%</b></div>'
    + '<p class="bq-sub" id="bqMsg"></p>'
    + '<div class="bq-dots"><i></i><i></i><i></i></div>'
    + '<div class="bq-stat" style="font-size:32px">'+esc(s.stat||"100,000+")+'</div>'
    + '<p class="bq-sub" style="margin-top:-14px">'+esc(s.statSub||"dogs on this plan")+'</p>'
    + '<div class="bq-revs">'
    + revs.map(function(r,k){
        return '<div class="bq-rev"><div class="hd"><img class="av" src="'+IMG.rev[k+4]+'" alt="" loading="lazy">'
             + '<div><div class="nm">'+esc(r.n)+'</div><div class="mt"><span class="bq-verified">'+esc(s.verifiedLabel||"✓ Verified")+'</span></div></div></div>'
/*BQP07*/
             + '<div class="st">'+STARS+'</div><div class="ti">'+esc(r.t)+'</div><div class="tx">'+esc(r.x)+'</div></div>';
      }).join("") + '</div>';

  var fg = host.querySelector("#bqFg"), pctEl = host.querySelector("#bqPct"),
      msg = host.querySelector("#bqMsg"), C = 326.7, p = 0;
  msg.textContent = lines[0] || "";
  var t = repeat(function(){
    p += Math.random()*4 + 1.6;
    if(p >= 100){
      p = 100; clearInterval(t);
      later(function(){ go(i+1); }, 420);
    }
    fg.style.strokeDashoffset = C - (C * p/100);
    pctEl.textContent = Math.floor(p) + "%";
    msg.textContent = lines[Math.min(lines.length-1, Math.floor(p/20))];
    bar.style.width = Math.round(92 + p*0.08) + "%";
  }, 110);
};

R.result = function(s){
  var v = score(), d = targetDate();
  var line1 = answers.night==="Most nights"
      ? "Quieter nights — usually the first thing owners notice"
      : "Less scratching through the day";
  var vr = vars();
  var resultValues = {score:String(v), band:band(v), goal:answers.goal||"less scratching", date:fmt(d)};
  function resultCopy(key, fallback, rich){
    var text = s[key] || fallback;
    return tok(rich ? text : esc(text)).replace(/\{(score|band|goal|date)\}/g,function(_,token){return esc(resultValues[token]);});
  }
  /* month sell-through, same device as the PDP scarcity block */
  var now = new Date(), dim = new Date(now.getFullYear(), now.getMonth()+1, 0).getDate();
  var pct = Math.round(84 + 15 * ((now.getDate()-1)/(dim-1)));
  var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];

  root.innerHTML = '<h1 class="bq-h1">'+h1(s.h1||[["hl","{Poss}"], " plan is ready"])+'</h1>'
    + '<p class="bq-sub" style="margin-top:-8px">'+resultCopy('resultScore',"Barrier score <strong>{score}</strong> \u00b7 {band}. Built around: {goal}.",true)+'</p>'
    + '<div class="bq-hold">'+resultCopy('resultHold','⏱ Held for')+' <b id="bqClock">15:00</b></div>'
    + '<div class="bq-hero" style="aspect-ratio:4/3"><img src="'+IMG.happy+'" alt="" loading="lazy"></div>'
    + '<div class="bq-plan"><div class="ttl">'+resultCopy('resultRoutine','{Poss} 90-day routine')+'</div><ul>'
    + '<li><span>1</span>'+resultCopy('resultDose',"One pump of Bloom Triple Collagen on dinner. That is the whole routine.")+'</li>'
    + '<li><span>2</span>'+resultCopy(answers.night==="Most nights"?'resultNight':'resultDay',line1+', typically inside the first month.')+'</li>'
    + '<li><span>3</span>'+resultCopy('resultRebuild',"Coat and barrier rebuild over 6\u20138 weeks \u2014 target {date}.")+'</li>'
    + '<li><span>4</span>'+resultCopy('resultRefund',"If {name} is no better in 90 days, you get your money back.")+'</li>'
    + '</ul></div>'
    + '<div class="bq-hero nat"><img src="'+IMG.dose+'" alt="'+resultCopy('resultDoseAlt','Daily dose by weight')+'" loading="lazy"></div>'
    + '<div class="bq-risk"><span class="ic">🛡</span><p>'+resultCopy('resultRisk',"You are not deciding whether this works. You are deciding whether to <strong>find out for free</strong> \u2014 90 days, and we refund you if nothing changes.",true)+'</p></div>'
    + '<div class="bq-scarce"><div class="rw"><span>'+months[now.getMonth()].toUpperCase()+'</span>'
    + '<span>'+pct+'% '+resultCopy('resultSold','sold')+' <span class="sub">'+resultCopy('resultBatch','of this month’s batch')+'</span></span></div>'
    + '<div class="tr"><i id="bqFill"></i></div></div>'
    + '<div class="bq-trust"><span>'+resultCopy('resultTrust1',"\ud83d\udee1 90-day guarantee")+'</span><span>'+resultCopy('resultTrust2',"\ud83d\udc1f 100% deep-sea cod")+'</span><span>'+resultCopy('resultTrust3',"\u2605 4.8 from 3,300+")+'</span></div>'
    + '<p class="bq-note">'+resultCopy('resultNote',"Bloom Triple Collagen is a food supplement, not a medicine. Keep giving anything your vet has prescribed.")+'</p>'
;
  /* The CTA is outside the animated .bq-wrap so it remains viewport-fixed. */
  var barEl = document.createElement("div");
  barEl.className = "bq-fixed";
  barEl.innerHTML = '<div>'+ctaBtn(tok(s.cta||"Start {poss} plan"))+'</div>';
  host.appendChild(barEl);
  document.body.classList.add("bq-has-fixed");
  bar.style.width = "100%";
  back.classList.remove("on");
  later(function(){ var f=host.querySelector("#bqFill"); if(f) f.style.width = pct+"%"; }, 150);

  /* reservation clock — survives a refresh, stops at zero */
  (function(){
    var el = host.querySelector("#bqClock"), KEY = "bqHoldUntil", until;
    try{ until = parseInt(sessionStorage.getItem(KEY),10); }catch(e){}
    if(!until || isNaN(until) || until < Date.now()) {
      until = Date.now() + 15*60*1000;
      try{ sessionStorage.setItem(KEY, String(until)); }catch(e){}
    }
    (function tick(){
      var left = Math.max(0, until - Date.now());
      var m = Math.floor(left/60000), s2 = Math.floor(left%60000/1000);
      el.textContent = m + ":" + (s2<10?"0":"") + s2;
      if(left > 0) later(tick, 1000);
    })();
  })();
  host.querySelector("#bqGo").addEventListener("click", function(){
    // Answers remain on this browser; avoid placing the dog's name in URLs/logs.
    var destination = new URL(END_URL, window.location.origin);
    destination.searchParams.set("quiz", "completed");
    destination.searchParams.set("q_score", String(v));
    window.location.assign(destination.href);
  });
};

function render(){
  cancelTimers();
  var s = STEPS[i];
  if(!s) return;
  document.body.classList.remove("bq-has-fixed");   /* only the result screen pins a CTA */
  var oldBar = host.querySelector(".bq-fixed"); if(oldBar) oldBar.remove();
  (R[s.type] || R.info)(s);
  progress();
  // Restore selection and validation after Back or refresh.
  if(s.key && answers[s.key] != null){
    var selected = Array.isArray(answers[s.key]) ? answers[s.key] : [String(answers[s.key])];
    root.querySelectorAll("[data-v]").forEach(function(button){
      var active = selected.indexOf(button.dataset.v) > -1;
      button.classList.toggle("sel", active);
      button.setAttribute("aria-pressed", String(active));
    });
    var next = host.querySelector("#bqGo");
    if(next && selected.length) next.disabled = false;
  }
  root.setAttribute("tabindex", "-1");
  root.focus({preventScroll:true});
  try{ sessionStorage.setItem(stateKey, JSON.stringify({version:1,index:i,history:history,answers:answers})); }catch(e){}
}

host.addEventListener("shopify:block:select", function(event){
  var marker = event.target.closest("[data-quiz-step]");
  if (!marker && event.detail?.blockId) marker = Array.from(host.querySelectorAll("[data-quiz-step]")).find(function(item){return item.dataset.quizBlockId === event.detail.blockId;});
  if (!marker) return;
  var stepValue = marker.dataset.quizStep;
  if (stepValue == null || stepValue.trim() === "") return;
  var target = Number(stepValue);
  if (!Number.isInteger(target) || !STEPS[target]) return;
  i = target;
  history = [];
  render();
}, {signal:lifecycle.signal});
i = nextIndex(i);
render();
return function(){
  lifecycle.abort();
  cancelTimers();
  var fixed = host.querySelector(".bq-fixed");
  if (fixed) fixed.remove();
  document.body.classList.remove("bq-has-fixed");
};
}
})();
